'use strict';

import remainScrollAfterCtaAction from '../../remainScrollAfterCtaAction';

var ajax = require('../../ajax'),
	dialog = require('../../dialog'),
    minicart = require('../../minicart'),
    progress = require('../../progress'),
    util = require('../../util'),
    Promise = require('promise'),
    _ = require('lodash'),
    TrackingLayer = require('../../modules/module.tracking-layer').default,
    stickySummary = require('../../sticky-summary');
    
import {shouldEnableSticky, initCartCloseButton} from '../../helpers/born.utils';

function initEventHandlers(callback) {
    let helpers = {
        isCartContext: function () {
            return pageContext && pageContext.ns && pageContext.ns === 'cart';
        },
        /**
     * @description Make the AJAX request to add an item to cart
     * @param {Element} form The form element that contains the item quantity and ID data
     * @returns {Promise}
     */
        addItemToCart: function (form) {
            var $form = $(form),
                $qty = $form.find('input[name="Quantity"]') || $form.find('select[name="Quantity"]');
            if ($qty.length === 0 || isNaN($qty.val()) || parseInt($qty.val(), 10) === 0) {
                $qty.val('1');
            }
            return Promise.resolve($.ajax({
                type: 'POST',
                url: util.ajaxUrl(Urls.addProduct),
                data: helpers.isCartContext() ? $(form).find(':input').serialize() : $form.serialize()
            })).then(function (response) {
                // handle error in the response
                if (response.error) {
                    throw new Error(response.error);
                } else {
                    return response;
                }
            });
        },
    
        /**
         * @description Handler to handle the add to cart event
         */
        addToCart: function (e) {
            e.preventDefault();
            e.stopPropagation();
            var $form = helpers.isCartContext() ? $(this).closest('.js-cart-pli') : $(this).closest('form'),
                $cartPage = $('.js-cart-page');
            
            var btnContxt = $(this).data('postpage');
            if(btnContxt !== undefined) { //check whether the page is from magazine
            	$form = $('.magAddtoCart');
            }else if($(this).data('addcart') !== undefined && helpers.isCartContext() ){//check whether the page is from cart
            	$form = $(this).closest('.pdpForm');
            }
            
            if (helpers.isCartContext() && $(this).data('addcart') === undefined ) {
                let $selectInput = $(this).find('.variation-select');
                if ($selectInput.length > 0 && $selectInput.val().length <= 0) {
                    return;
                }
                progress.show($('body'));
            }
    
            helpers.addItemToCart($form).then(function (response) {
                var $uuid = $form.find('input[name="uuid"]');
                
                if(!shouldEnableSticky()) {
                    window.scroll(0,0);
                }
                
                if(btnContxt !== undefined) {
                	$form[0].reset();
                	var obj = $(this);
                	var container = $('.magazine-article__section');
                	var btn = container.find('button[type="button"].btn-add-to-bag:not(.out-stk-btn)');
                	btn.attr('disabled', true);
                	container.find('.add-to-bag').removeClass('active');

                	btn.html(Resources.ADD_TO_CART_BUTTON);
                	btn.attr('title', Resources.ADD_TO_CART_BUTTON);
                }
                //If $uuid.length exists, this product is being updated. 
                if ($uuid.length > 0 && $uuid.val().length > 0) {
                    // page.refresh();
                    TrackingLayer.pushData('shopping_bag: ' + window.Resources['BAG_UPDATED']);

                    if ($cartPage.length > 0) {
                        $cartPage.replaceWith($(response));
                        initCartCloseButton();
                    }

                    callback().then(() => {
                        progress.hide();
                    });
                } else {
                    // do not close quickview if adding individual item that is part of product set
                    // @TODO should notify the user some other way that the add action has completed successfully
                    if (!$(this).hasClass('sub-product-item')) {
                        dialog.close();
                    }

                    TrackingLayer.pushData('shopping_bag: ' + window.Resources['PRODUCT_ADDED']);

                    // Hide Minicart popup only for PDP mobile web, but the cart should update.
                    let showMinicartPopup = true;
                    if($('.pt_product-details').length > 0 && $(window).innerWidth() < 768) {
                        showMinicartPopup = false;
                    }
                    minicart.show(response, showMinicartPopup);

                    // Show cart notification message
                    if(!showMinicartPopup) {
                        const $addToCart = $('#add-to-cart');
                        const notification = $(`
                            <div class="pdp-cart-notification display--small-only w-100 align--center">
                                <i class="icon--circled-checkmark"></i>
                                <span class="poppins txt--medium">${Resources.PDP_CART_NOTIFICATION}</span>
                            </div>
                        `);
                        const buttonText = $(`
                            <span>
                                <i class="icon--circled-checkmark txt--normal"></i>
                                <span>${Resources.PDP_PRODUCT_ADDED_TEXT}</span>
                            </span>
                        `);
                        const currentBtnText = $addToCart.html();
                        $addToCart.html(buttonText.html());
                        $('.qty-add-wrapper').prepend(notification);
                        notification.hide().fadeIn(500);
                        setTimeout(function() {
                            notification.fadeOut(500, function() {
                                $(this).remove();
                                $addToCart.html(currentBtnText);
                            });
                        }, 2500);
                    }
                    if((helpers.isCartContext() && $form.find('#add-to-cart').length > 0 && $form.find('#add-to-cart').data('addcart')=== true)
                    || ($('.listcartadd') !== 'undefined' && $('.listcartadd').val().length > 0)){
                        location.reload(true);
                    }
                }
				if (!window.ApplePaySession) {
					$('#ckoApplePayButton').hide();
				}
                if($('.show-ship-msg-space').length > 0) {
                    $('.breadcrumb-spacer').addClass('has-approach-promo');
                    $('.show-ship-msg-space').remove();
                }else{
                    $('.breadcrumb-spacer').removeClass('has-approach-promo');
                }
            }.bind(this));
        },
    
        /**
         * @description Handler to handle the add all items to cart event
         */
        addAllToCart: function (e) {
            e.preventDefault();
            var $productForms = $('#product-set-list').find('form').toArray();
            Promise.all(_.map($productForms, this.addItemToCart))
                .then(function (responses) {
                    dialog.close();
                    // show the final response only, which would include all the other items
                    minicart.show(responses[responses.length - 1]);
                });
        }     
        
    };

    const {addItemToCart, addToCart, addAllToCart, isCartContext, handleCartSelect} = helpers;
    
    $('#add-to-cart[disabled]').attr('title', $.trim($('.availability-msg').text()));
    $('#pdpMain, #wishlistList').off('click','.add-to-cart').on('click', '.add-to-cart', addToCart);
    $('#pdpMain button:not([disabled])').on('touchstart', '.add-to-cart', addToCart);
    $('#wishlistList').on('touchstart', '.add-to-cart', addToCart);
    $('#add-all-to-cart').on('click touchstart', addAllToCart);
    
    if($('.magAddtoCart').length > 0) {
    	$(document).on('click','.btn-add-to-bag', addToCart);
    	$(document).on('click','.link-add-to-bag', addToCart);
    }
    
    if (isCartContext()) {
        $('.js-cart-wrapper').on('change', '.js-variation-select', addToCart);
    }

    remainScrollAfterCtaAction($('a.add-to-wishlist'));
}

function init(callback) {
    callback = callback || new Promise((resolve) => resolve());
    initEventHandlers(callback);
}
/**
 * @function
 * @description Binds the click event to a given target
 */
module.exports = init;


// WEBPACK FOOTER //
// ./cartridges/app_modist_core/cartridge/js/pages/product/addToCart.js